import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/users'

class UsersDataService extends RestApiDataService {

}

export default new UsersDataService(BASE_ENTITY_URL)
